export type SSOProvider = "GOOGLE" | "MICROSOFT" | "SAML";

export const SSO_PROVIDER_LABEL: Record<SSOProvider, string> = {
  GOOGLE: "Google",
  MICROSOFT: "Microsoft",
  SAML: "SAML",
};

export interface SSOProviderInfo {
  provider: SSOProvider;
  kind: "oauth" | "saml";
  enabled: boolean;
  display_name: string;
}

export interface SSOStatusResponse {
  enabled_providers: SSOProviderInfo[];
}

export interface SSOLoginResponse {
  authorization_url: string;
}

export interface SSOConfigurationRead {
  id: string;
  provider: SSOProvider;
  is_enabled: boolean;
  client_id?: string | null;
  tenant?: string | null;
  allowed_email_domains?: string | null;
  idp_entity_id?: string | null;
  idp_sso_url?: string | null;
  idp_certificate?: string | null;
  sp_entity_id?: string | null;
  default_role?: string;
  jit_provisioning?: boolean;
  attribute_mapping?: Record<string, unknown> | null;
}

export interface SSOConfigurationUpsert {
  is_enabled?: boolean;
  client_id?: string | null;
  client_secret?: string | null;
  tenant?: string | null;
  allowed_email_domains?: string | null;
  idp_entity_id?: string | null;
  idp_sso_url?: string | null;
  idp_certificate?: string | null;
  sp_entity_id?: string | null;
  default_role?: string;
  jit_provisioning?: boolean;
  attribute_mapping?: Record<string, unknown> | null;
}

export interface SSOIdentity {
  id: string;
  provider: SSOProvider;
  subject: string;
  email: string | null;
  display_name: string | null;
  last_login_at: string | null;
  created_at: string | null;
}
